

export class Descriptions {
    short: string;
    long: string;
    tech: string;
    parts: string;
}


export class Images {
    thumbnail: string = null;
    folder: string = null;
    scene: string = null; // TODO: Decouple
}


export class Links {
    tech: string = null;
}


export class Taxonomy {
    categories: Array<string> = null;
    currentCategoryId: string = null; // Configured at run time
    sortOrder: Object = null; // Sorts the order of the products in category and in cart/summary. +/- 0
    zIndex: Object = null; // Sorts the order of products in scene. +/- 0 // TODO: Decouple
    series: string = null;
}


export class Options {
    enabledListsIds: Array<string> = null;
    list: Object = null;
    selected: Object = null;
    dropdownIsActive: boolean = false;
}


export class Package {
    config: {
        staticProducts: Array<any>;
        dynamicProducts: Array<any>;
    } = null;
    products: Array<Product> = null;
}


export class Tooltip {
    top: number = 10;
    left: number = 10;
    width: number = 10;
    height: number = 10;
    orientation: string = null;
}


export class VSpa {
    spaFrameIsVisible: boolean = false;
    standardGeneratorIsVisible: boolean = false;
    isSuperCompatible: boolean = false;
    isSuperGenerator: boolean = null;
}


export class ProductConfig {
    _uuid: number = null;
    code: string = null;
    partnumber: string = null;
    previewname: string = null;
    name: string = null;
    price: number = null;
    descriptions: Descriptions = null;
    images: Images = null;
    links: Links = null;
    taxonomy: Taxonomy = null;
    options: Options;
    package: Package = null;
    dynamicProperties: Object = null;
    tooltips: Array<Tooltip> = null;
    vSpa: VSpa = null;
}


export class Product {

    
    constructor (config: ProductConfig) {
        this._uuid = config._uuid;
        this._code = config.code;
        this.code = config.code;
        this.partnumber = config.partnumber;
        this.previewname = config.previewname;
        this.name = config.name;
        this.price = config.price;
        this.descriptions = config.descriptions;
        this.images = config.images;
        this.links = config.links;
        this.taxonomy = config.taxonomy;
        this.options = config.options;
        this.dynamicProperties = config.dynamicProperties;
        this.package = config.package;
        this.tooltips = config.tooltips;
        this.vSpa = config.vSpa;
    }

    // Basic
    public _uuid: number = null;
    public _code: string = null;
    // Variables cached from the environment.
    // Needed by some products for dynamic properties update process.
    public _globals: Object = null;
    public code: string = null;
    public partnumber: string = null;
    public previewname: string = null;
    public name: string = null;
    public price: number = null;
    public isVisible: Boolean = true;

    // Standard
    public descriptions: Descriptions = null;
    public images: Images = null;
    public links: Links = null;
    public taxonomy: Taxonomy = null;
    public options: Options = null;
    public dynamicProperties: Object = null;
    public package: Package = null;

    // Vspa
    // TODO: Decouple
    public vSpa: VSpa;

    // Utils
    public refreshState;
    public getPrice;
    // public getCategories;
    public getCurrentCategory;
    public getNameTags;
    public getNameTagsSummary;

    // public selectOption;
    public getClone;
    public syncWithProduct;
    public updateDynamicProperties;
    public generatePackageProducts;
    public displayProductDetails;

    // Cart
    public isAddedToCart: boolean = false;
    public toggleInCart;
    public addToCart;
    public removeFromCart;

    // Requires, Excludes // Should be bundled in one sub-object
    // public isCompatibleWithCart: boolean = true;
    // public isRequiringOtherProds: boolean = false;
    // public isExcludingOtherProds: boolean = false;
    // public isRequiredByOtherProds: boolean = false;
    // public isExcludedByOtherProds: boolean = false;
    // public requires: Array<string> = null;
    // public excludes: Array<string> = null;
    // public requiredBy: Array<string> = null;
    // public excludedBy: Array<string> = null;
    // public checkIfRequires;
    // public checkIfExcludes;
    // public checkIfIsRequiredBy;
    // public checkIfIsExcludedBy;

    // Multi Select
    // public isSelected: boolean = false;
    // public toggleSelect;
    // public select;
    // public deselect;

    // Tooltips
    // TODO: Decouple
    public tooltips: Array<Tooltip> = null;
    public tooltipIsVisible: boolean = false;
    public tooltipIsHovered: boolean = false;
    public displayTooltip;
    public hideTooltip;

    // Scene
    // TODO: Decouple
    public isAddedToScene: boolean = false;
    public toggleInScene;
    public addToScene;
    public removeFromScene;
    public getSceneImage;


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/classes/product.ts